import { BaseFieldRenderer } from './base-field-renderer';
import { CheckboxFieldJsonData, FieldOption, RenderOptions } from '../../models/element-types';
import { TranslateUtils } from '../../utils/translate.utils';
import { HtmlUtils } from '../../utils/html.utils';

export class CheckboxFieldRenderer extends BaseFieldRenderer<CheckboxFieldJsonData> {
    protected override get defaultData(): CheckboxFieldJsonData {
        const choice = TranslateUtils.CHECKBOX_FIELD.CHOICE;
        return {
            id: '',
            type: 'checkbox',
            label: TranslateUtils.CHECKBOX_FIELD.LABEL,
            required: false,
            hiddenLabel: false,
            options: [
                { value: `${choice} 1`, label: `${choice} 1` },
                { value: `${choice} 2`, label: `${choice} 2` },
                { value: `${choice} 3`, label: `${choice} 3` }
            ]
        };
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected override renderContent(fieldJsonData: CheckboxFieldJsonData, options: RenderOptions = {}): HTMLElement {
        const elementContent = document.createElement('div');
        elementContent.classList.add('element-content');

        const fieldset = document.createElement('fieldset');
        fieldset.classList.add('field', 'checkbox');
        if (fieldJsonData.required) {
            fieldset.classList.add('required');
        }

        fieldset.setAttribute('min-count', fieldJsonData.minCount ?? '');
        fieldset.setAttribute('max-count', fieldJsonData.maxCount ?? '');

        if (!fieldJsonData.hiddenLabel) {
            const legend = document.createElement('legend');
            legend.classList.add('label');
            this.applyHtmlLabel(legend, fieldJsonData.label);
            fieldset.appendChild(legend);
        }

        const optionsContainer = document.createElement('div');
        optionsContainer.classList.add('options');

        const fieldOptions = fieldJsonData.options || [];
        const fieldLabel = this.getPlainLabel(fieldJsonData.label);
        fieldOptions.forEach((option, index) => {
            const optionElement = this.createOption(option, fieldJsonData.id, index, fieldLabel);
            optionsContainer.appendChild(optionElement);
        });

        fieldset.appendChild(optionsContainer);

        const errorContainer = this.renderErrorContainer(fieldJsonData);
        fieldset.appendChild(errorContainer);

        if (fieldJsonData.showDescription) {
            const description = this.renderDescription(fieldJsonData);
            fieldset.appendChild(description);
        }

        elementContent.appendChild(fieldset);

        return elementContent;
    }

    private createOption(option: FieldOption, parentId: string, index: number, fieldLabel: string): HTMLElement {
        const optionElement = document.createElement('div');
        optionElement.classList.add('option');

        const inputId = `${parentId}_opt_${index}`;

        const input = document.createElement('input');
        input.id = inputId;
        input.type = 'checkbox';
        input.classList.add('input');
        input.name = parentId;
        input.value = HtmlUtils.escapeHtml(option.value);
        input.dataset['label'] = fieldLabel;

        const label = document.createElement('label');
        label.classList.add('label');
        label.setAttribute('for', inputId);
        label.innerHTML = HtmlUtils.sanitize(option.label);

        optionElement.append(input, label);

        return optionElement;
    }

    protected renderInput(): HTMLElement {
        return document.createElement('div');
    }
}
